import { FC, ReactNode } from 'react';
import InfoIcon from '@/assets/info.svg';
import SuccessIcon from '@/assets/success-check.svg';
import WarningIcon from '@/assets/warning.svg';
import { cx } from '@/utils/cx';

export type InfoBarProps = {
  className?: string;
  text: string;
  variant?: 'info' | 'success' | 'error';
  /** Optional supplementary content rendered inside the bar, below the text. */
  children?: ReactNode;
};

export const InfoBar: FC<InfoBarProps> = ({
  className,
  text,
  variant = 'info',
  children,
}) => (
  <div
    {...(variant === 'error' ? { role: 'alert' } : {})}
    className={cx(
      'flex w-full flex-row gap-3 rounded-xl bg-blue-50 p-4 text-blue-400',
      children ? 'items-start' : 'items-center',
      variant === 'success' && 'bg-green-50 text-green-400',
      variant === 'error' && 'bg-warningTint text-warning',
      className,
    )}
  >
    {variant === 'info' && <InfoIcon />}
    {variant === 'success' && <SuccessIcon />}
    {variant === 'error' && <WarningIcon />}
    <div className="flex w-full flex-col gap-2">
      <div
        className={cx(
          'text-sm font-normal text-blue-700',
          variant === 'success' && 'text-green-800',
          variant === 'error' && 'text-warningShade',
        )}
      >
        {text}
      </div>
      {children}
    </div>
  </div>
);
